import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export const buildModalUrl = (appPath, hostAppName, instanceId) => {
  const env = enviro.deployed() ? 'app' : 'local';
  let url = `${getFullUrl(env)}${appPath}/${PortalIdParser.get()}?hostAppName=${hostAppName}&variant=uiiframe`;
  if (instanceId) {
    url += `&instanceId=${instanceId}`;
  }
  return url;
};